import { find } from 'lodash';
import { DEFAULT_OBJECT } from '../constants';

export const assignValue = (key) => (state, value) => {
  state[key] = value;
};

export const resetValue = (key) => (state) => {
  state[key] = DEFAULT_OBJECT;
};

export const getIncludedData = (stateAttribute, relationship) => {
  let result;
  if (stateAttribute.data && stateAttribute.included.length) {
    result = find(stateAttribute.included, stateAttribute.data.relationships[relationship].data);
  }
  if (!result) {
    result = { attributes: {} };
  }
  return result;
};

export const getIncludedDataFor = (element, stateAttribute, relationship) => stateAttribute
  && find(stateAttribute.included, element.relationships[relationship].data);

export const getAssociatedList = (element, baseData, relationship) => {
  if (!element.relationships) {
    return [];
  }
  const includedData = baseData.included || [];

  return element.relationships[relationship].data.map((relData) => find(includedData, relData));
};
